import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { groupBy, orderBy, sortBy, sum } from 'lodash';
import { InvoiceService } from 'src/app/services/invoice-service/invoice.service';
import { EstimateDetailTypeEnum, EstimateStatusTypes } from 'src/app/shared/enums/estimate/estimate.enum';
import { FileTypes, ImageContextTypes } from 'src/app/shared/enums/files/files.enum';
import { InvoiceStatusEnum } from 'src/app/shared/enums/invoice/invoice.enum';
import { PaymentTypes, PaymentStatusTypes } from 'src/app/shared/enums/payment/payment.enum';
import { Files } from 'src/app/shared/interfaces/files.interface';
import { InvoiceEntityDTO, InvoiceEstimatedLineItemsDTO } from 'src/app/shared/invoice/invoice.interface';
import { PortalUrlContentDetailsModal } from 'src/app/shared/modals/portal-url-content-details.modal';
import { concatFilePath, decimal2, getCustomerNameWithCompany, getPhotoDisplayUrl, IsInvoicePublished, markThumbnailFailed, NumberUtil, objectIsEmpty } from 'src/app/shared/utils/util-function';
import { hasPrintableAddress } from 'src/app/shared/utils/address-printable';
import { parsePhoneNumber } from 'libphonenumber-js';
import { LogRocketService } from 'src/app/services/logrocket-service/logrocket.service';
import { GlobalStateService } from 'src/app/services/global-state.service';
import { PortalUrlService } from 'src/app/services/portal-url.service/portal-url.service';
import * as _ from 'lodash';
@Component({
  selector: 'projul-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit, OnChanges {
  @ViewChild('iframe', { static: true }) printContent: any;
  @Input() invoice: PortalUrlContentDetailsModal;

  companyLogo: Files;
  filesList: Files[] = [];
  photosList: Files[] = [];
  invoiceStatusEnum = InvoiceStatusEnum;
  estimateStatusTypes = EstimateStatusTypes;
  currentDate: Date = new Date();
  @Input() estimateChangeOrderLineItems: { Name: string, LineItems: InvoiceEstimatedLineItemsDTO[], isPrice: boolean }[];
  @Input() estimateLineItems = [] as InvoiceEstimatedLineItemsDTO[];
  PaymentStatusTypes = PaymentStatusTypes;
  DefaultPrintedPhotoSize: number;
  photoThumbUrl = getPhotoDisplayUrl;
  onThumbError = markThumbnailFailed;
  hasPrintableAddress = hasPrintableAddress;

  constructor(private invoiceService: InvoiceService, private logRocketService: LogRocketService,
    private globalStateService: GlobalStateService, private portalUrlService: PortalUrlService
  ) {
  }

  async ngOnInit() {
    this.globalStateService.checkOutDatedDataObservable.pipe().subscribe(async (res: any) => {
      let updatedDate = (await this.portalUrlService.getUpdatedDateOfEntity(this.invoice.UrlId))?.Response as any;
      if (updatedDate != null && this.invoice.Item && this.invoice.Item.UpdatedDate < updatedDate) {
        this.globalStateService.setClientPortalRelatedDataChanges();
      }
    });

    this.applyInvoiceInput();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-derive state on subsequent @Input updates (e.g. SignalR-driven refetch after
    // a payment lands). Skip the very first change — ngOnInit already calls applyInvoiceInput.
    const change = changes['invoice'];
    if (change && !change.firstChange) {
      this.applyInvoiceInput();
    }
  }

  private applyInvoiceInput(): void {
    this.photosList = this.invoice.Item.Files.filter((x: any) => x.FileType === FileTypes.Image && x.ImageContextType === ImageContextTypes.Gallery);
    this.filesList = this.invoice.Item.Files.filter((x: any) => x.FileType === FileTypes.Document && x.ImageContextType === ImageContextTypes.Gallery);

    (this.filesList || []).forEach(o => {
      if (!!o.FileName)
        o.FileNameURI = encodeURIComponent(o.FileName);
      while (o.FileNameURI?.indexOf('#') > -1)
        o.FileNameURI = (o.FileNameURI).replace('#', '%23');
    })

    let companyLogoList: any[] = this.invoice.Item.Files.filter((x: any) => x.FileType === FileTypes.Image && x.ImageContextType === ImageContextTypes.Settings);
    this.companyLogo = companyLogoList[0];
    let invoiceEntity = (this.invoice.Item as InvoiceEntityDTO);

    console.log('Opened Invoice With Id: ', invoiceEntity.Id);

    this.estimateChangeOrderLineItems = this.invoiceService.groupChangeOrderLineItems(invoiceEntity.EstimatedLineItems);
    this.estimateLineItems = (invoiceEntity.EstimatedLineItems || []).filter((x: InvoiceEstimatedLineItemsDTO) => x.EstimateType == EstimateDetailTypeEnum.Normal);
    this.invoice.Item.companyLogo = this.companyLogo?.UriPath + this.companyLogo?.FileName;
    this.invoiceService.invoiceProjectFinancials(this.invoice.Item);
    this.logStackDataInSessionStack();

    this.DefaultPrintedPhotoSize = this.invoice.Item?.DefaultPrintedPhotoSize > 0 ? this.invoice.Item?.DefaultPrintedPhotoSize : (this.invoice?.settings?.InvoiceDefaultPrintedPhotoSize || 1);
  }

  noteListImages: any = []
  openImageInFullScreen(item: any, itemList: any) {
    this.noteListImages = itemList
    // this.photoSwipe.openImage(0, item);
    // this.globalStateService.setOpenLightboxObservable({Index:item.Id,Image: item,isGallery: true})

    this.globalStateService.setOpenLightboxForNoteObservable(this.noteListImages)
    let index = this.noteListImages?.findIndex((f: any) => f.Id === item.Id);
    this.globalStateService.setOpenLightboxObservable({ Index: index, Image: item, isGallery: true, isNoteList: false })

  }

  concatFilePath(baseUri: any, fileName: any) {
    return concatFilePath(baseUri, fileName);
  }

  // A blank invoice name only hides the printed header line; wording that names the company falls back.
  contactCompanyName(companyName: string, accountCompanyName: string): string {
    return companyName?.trim() || accountCompanyName || '';
  }

  logStackDataInSessionStack() {

    let CustomerFirstName = (this.invoice.Item?.CustomerFirstName || this.invoice.Item?.Customer?.FirstName || "");
    let CustomerLastName = (this.invoice.Item?.CustomerLastName || this.invoice.Item?.Customer?.LastName || "");
    let CustomerEmail = (this.invoice.Item?.CustomerEmail || this.invoice.Item?.Customer?.Emails[0]?.Email || "");

    const sessionStackData = {
      userId: window.location.href,
      email: "" + CustomerEmail,
      displayName: "" + (CustomerFirstName + " " + CustomerLastName),

      customerFirstName_str: "" + CustomerFirstName,
      customerLastName_str: "" + CustomerLastName,
      customerCompanyName_str: "" + (this.invoice.Item?.Customer?.CompanyName || ""),
      customerEmail_str: "" + CustomerEmail,
      customerPhoneNumber_str: "" + this.formatNumberForPreivew(this.invoice.Item?.CustomerPhone || this.invoice.Item?.Customer?.PhoneNumbers[0]?.PhoneNumber || ""),
      estimateNumber_str: "" + (this.invoice?.Item?.EstimateEntity?.EstimateDetails[0]?.EstimateNumber || ""),
      estimateSubtotalEstimateValue_str: "" + ((this.invoice.Item.EstimateEntity?.EstimateValues?.TotalWithoutTax || 0)),
      estimateCompanyName_str: "" + (this.invoice?.Item?.CompanyName || ""),
      estimateEmail_str: "" + (this.invoice?.Item?.CompanyEmail || ""),
      fromPreview_bool: !!this.invoice?.IsPreview,
      invoiceStatus_str: "" + (this.invoice?.Item?.Status),
      invoiceTotal_str: "" + (this.invoice.Item?.Total || 0),
      invoiceNumber_str: "" + (this.invoice.Item?.InvoiceNumber || ""),
      invoiceBalanceDueRemaining_str: "" + (this.invoice.Item?.RemainingBalance || ""),
    };

    this.logRocketService.initializeLogRocket();
    this.logRocketService.identify(sessionStackData);
  }


  // formate Phone Number 
  formatNumberForPreivew(phoneNo: any) {
    try {
      const phoneNumber = parsePhoneNumber(phoneNo, 'US')
      return phoneNumber.formatNational()
    }
    catch {
      return phoneNo
    }
  }


  /** Download filename shape: Invoice_{number}_{date}_{client}_{project}.pdf */
  generateDownloadFilename(): string {
    const parts: string[] = [];
    
    // Get current date in yyyy-mm-dd format
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    const invoiceItem = this.invoice.Item as any;

    // 1. Document Title (use "Invoice" if title is blank)
    let title = invoiceItem?.Title?.trim() || 'Invoice';
    // Replace spaces with underscores
    title = title.replace(/\s+/g, '_');
    parts.push(title);
    
    // 2. Invoice Number
    if (invoiceItem?.InvoiceNumber) {
      parts.push(invoiceItem.InvoiceNumber.toString());
    }
    
    // 3. Date
    parts.push(dateStr);
    const projectName = invoiceItem?.ProjectName || 
                       invoiceItem?.ProjectV2Entities?.Name || '';
    // 4. Customer name (if available)
    const customerName = getCustomerNameWithCompany(invoiceItem?.Customer);
    if (projectName) {
      parts.push(projectName.trim().replace(/\s+/g, '_'));  
    }else{
      parts.push(customerName.replace(/\s+/g, '_'));
    }    
    // Join parts with underscore and sanitize
    const filename = parts.join('_');
    return filename.replace(/[^a-zA-Z0-9_\-()]/g, '_') + '.pdf';
  }

  handlePrintPDF() {
    // Generate custom filename
    const customFilename = this.generateDownloadFilename();
    
    // Store original title
    const originalTitle = document.title;
    
    // Set document title to custom filename (without .pdf extension)
    document.title = customFilename.replace('.pdf', '');
    
    // Trigger print dialog
    window.print();
    
    // Restore original title after a short delay
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  }

  isEmpty(obj: any) {
    return !obj || objectIsEmpty(obj);
  }


  getPaymentType(type: number) {
    return PaymentTypes[type]
  }

  getPaymentTypeString(type: PaymentTypes): string {
    switch (type) {
      case PaymentTypes.Cash:
        return 'Cash';
      case PaymentTypes.Check:
        return 'Check';
      case PaymentTypes.Card:
        return 'Card';
      case PaymentTypes.ACH:
        return 'ACH';
      case PaymentTypes.Zelle:
        return 'Zelle';
      case PaymentTypes.Venmo:
        return 'Venmo';
      case PaymentTypes.ApplePay:
        return 'Apple Pay';
      case PaymentTypes.Bitcoin:
        return 'E-Transfer';
      default:
        return 'Unknown';
    }
  }

  getPaymentStatusType(type: number) {
    return PaymentStatusTypes[type]
  }

  getTotalFontSize(value: number): string {
    const abs = Math.abs(value || 0);
    const formatted = '$' + abs.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const str = (value < 0 ? '-' : '') + formatted;
    if (str.length > 14) return '12px';
    if (str.length > 12) return '14px';
    return '16px';
  }
}
